import { useTheme } from '@mui/material'
import palette from 'ComponentLibrary/src/styles/colors'
import { isUndefined } from 'lodash'

const opacityToHex = (opacity: number) => {
    // make sure number is betwen 0-1
    opacity = Math.min(Math.max(0, opacity), 1)
    const hex = Math.round(opacity * 255).toString(16)
    return hex.length === 1 ? `0${hex}` : hex
}

export const useColors = () => {
    const theme = useTheme()

    const getColor = (index: number, shaded = false, opacity?: number) => {
        const COLORS = Object.values(shaded ? theme.palette.chartColorsShaded : theme.palette.chartColors)
        return `${COLORS[index % COLORS.length]}${!isUndefined(opacity) ? opacityToHex(opacity) : ''}`
    }

    /**
     *
     * @param color - color in hex format
     * @param opacity - number from 0-1
     * @returns hex with alpha values
     */
    const changeOpacity = (color: string, opacity: number) => {
        return `${color}${opacityToHex(opacity)}`
    }

    return { getColor, changeOpacity }
}

export const getTrendColor = (trend?: number, inverse?: boolean) =>
    trend === undefined || trend === 0
        ? palette.customtext.black54
        : (trend > 0 && !inverse) || (trend < 0 && inverse)
          ? palette.primary2.green100
          : palette.status.red
